import window from 'global/window';
import logger from '../common/logger';
import { getEnvironmentConstant } from '../common/utilities';
import { PKCE_ENV, ROUTER_BASENAME } from '../common/constants';

// Map PKCE envs to CFP auth provider environments.
const mapCfpEnvironment = (pkceEnv) => {
  switch (pkceEnv) {
    case 'prd':
      return 'prod';
    case 'stg':
    case 'dev':
    case 'int':
      return pkceEnv;
    default:
      return 'prod';
  }
};

// Register CFP auth provider and resolve when registration completes or times out.
// eslint-disable-next-line import/prefer-default-export
export const registerCfpAuthProvider = ({ clientId, env, language }) => {
  const providerId = 'etxSupportAuthProvider';
  const maxAttempts = 50;
  let attempts = 0;

  if (!clientId) {
    logger.warn('[CFP] Missing clientId, skipping auth provider registration');
    return Promise.resolve(false);
  }

  return new Promise((resolve) => {
    const intervalId = setInterval(() => {
      attempts += 1;
      const cfpAuth = window?.cfp?.providers?.auth;
      const cfpLocalization = window?.cfp?.providers?.localization;

      if (!cfpAuth?.register) {
        if (attempts === 1) {
          logger.info('[CFP] Auth provider registry not ready yet');
        }
        if (attempts >= maxAttempts) {
          logger.warn(
            '[CFP] Auth provider registry not available after waiting'
          );
          clearInterval(intervalId);
          resolve(false);
        }
        return;
      }

      try {
        if (window.etxCfpAuthRegistered) {
          logger.info('[CFP] Auth provider already registered, skipping');
          clearInterval(intervalId);
          resolve(true);
          return;
        }
      } catch (error) {
        logger.debug('[CFP] Auth provider registration guard failed', error);
      }

      if (cfpLocalization?.init) {
        try {
          cfpLocalization.init(language);
          logger.info('[CFP] Localization provider initialized', language);
        } catch (error) {
          logger.warn('[CFP] Localization init failed', error);
        }
      }

      const redirectUri = `${window?.location?.origin}${getEnvironmentConstant({
        key: ROUTER_BASENAME,
        env
      })}/auth`;
      const logoutRedirectUri = `${
        window?.location?.origin
      }${getEnvironmentConstant({
        key: ROUTER_BASENAME,
        env
      })}`;
      const cfpEnvironment = mapCfpEnvironment(
        getEnvironmentConstant({ key: PKCE_ENV, env })
      );

      try {
        cfpAuth.register({
          clientId,
          redirectUri,
          logoutRedirectUri,
          environment: cfpEnvironment,
          scope: 'data:read openid user-profile:read',
          useRefreshTokens: true
        });
        window.etxCfpAuthRegistered = true;
        logger.info('[CFP] Auth provider registered', providerId);
        resolve(true);
      } catch (error) {
        logger.error('[CFP] Auth provider registration failed', error);
        resolve(false);
      }
      clearInterval(intervalId);
    }, 200);
  });
};
